var map = {
	"./E@2x.png": 171,
	"./ENE@2x.png": 172,
	"./ESE@2x.png": 173,
	"./N@2x.png": 174,
	"./NE@2x.png": 175,
	"./NNE@2x.png": 176,
	"./NNW@2x.png": 177,
	"./NW@2x.png": 178,
	"./S@2x.png": 179,
	"./SE@2x.png": 180,
	"./SSE@2x.png": 181,
	"./SSW@2x.png": 182,
	"./SW@2x.png": 183,
	"./W@2x.png": 184,
	"./WNW@2x.png": 185,
	"./WSW@2x.png": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;